import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ArrowDownIcon, XCircleIcon, SparklesIcon } from 'lucide-react';
export function TransformationSection() {
  return <section className="bg-cream py-16 md:py-24" data-id="element-143">
      <div className="max-w-6xl mx-auto px-4" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-146">
            Tu transformación empieza aquí
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-147" />
        </motion.div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-148">
          {/* Before Card */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-red-100 w-full" data-id="element-149">
            <div className="flex items-center gap-3 text-red-400 mb-6 font-semibold tracking-wide uppercase text-sm" data-id="element-150">
              <XCircleIcon className="w-5 h-5" data-id="element-151" />
              <span data-id="element-152">Antes</span>
            </div>
            <p className="text-xl md:text-2xl text-navy/60 font-medium leading-relaxed" data-id="element-153">
              "Cansada, limitada y sin opciones claras de crecimiento."
            </p>
          </motion.div>

          {/* Arrow */}
          <motion.div initial={{
          opacity: 0,
          scale: 0
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="w-16 h-16 bg-gold rounded-full flex items-center justify-center text-navy shrink-0 shadow-lg" data-id="element-154">
            <ArrowRightIcon className="w-8 h-8 hidden md:block" data-id="element-155" />
            <ArrowDownIcon className="w-8 h-8 md:hidden" data-id="element-156" />
          </motion.div>

          {/* After Card */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="flex-1 bg-navy p-8 md:p-10 rounded-3xl shadow-xl border border-gold/30 w-full relative overflow-hidden" data-id="element-157">
            <div className="absolute -right-10 -top-10 w-40 h-40 bg-gold/20 blur-3xl rounded-full" data-id="element-158" />
            <div className="flex items-center gap-3 text-gold mb-6 font-semibold tracking-wide uppercase text-sm relative z-10" data-id="element-159">
              <SparklesIcon className="w-5 h-5" data-id="element-160" />
              <span data-id="element-161">Después</span>
            </div>
            <p className="text-xl md:text-2xl text-white font-medium leading-relaxed relative z-10" data-id="element-162">
              "Con una forma práctica de empezar a construir ingresos propios
              desde tu celular."
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}